import { startsWord, wordsOf } from '../boundaries'
import { isAppointment, isPast, whenValueOf } from './when'
import type { Candidate, Recognizer } from './types'

/** **`{Freitag}`** wie bei Todoist — gilt in jeder Sprache; was in der Klammer steht, liest die App-Sprache. */
export const recognizeDeadlineBraces: Recognizer = ({ text, masked, options, lang }) => {
  const found: Candidate[] = []
  for (const match of masked.matchAll(/\{([^{}]+)\}/gu)) {
    const inner = match[1]!
    const result = lang.chrono.parse(inner, options.now, { forwardDate: true })[0]
    // Die Klammer meint ein Datum — es muss gleich am Anfang stehen, nicht irgendwo darin.
    if (!result || result.index !== inner.length - inner.trimStart().length) continue
    const { date, time, period } = whenValueOf(result, lang)
    if (isPast({ date }, options.now)) continue
    const start = match.index!
    const end = start + match[0].length
    found.push({ kind: 'deadline', start, end, text: text.slice(start, end), value: { date, time, period } })
  }
  return found
}

/**
 * **„bis Freitag“ / „by friday“.** Steht vor „bis“ eine Zahl, ist es eine Zeitspanne („9 bis 10 Uhr“)
 * und gehört dem Wann. Direkt nach einer Wiederholung hat die es schon als ihr Ende genommen.
 */
export const recognizeDeadlineWords: Recognizer = ({ text, masked, options, lang }) => {
  const words = wordsOf(masked)
  const found: Candidate[] = []
  words.forEach((word, i) => {
    if (!lang.deadlineWords.includes(word.text.toLowerCase()) || !startsWord(text, word.start)) return
    if (i > 0 && /\d$/u.test(words[i - 1]!.text)) return
    const rest = masked.slice(word.end)
    const result = lang.chrono.parse(rest, options.now, { forwardDate: true })[0]
    if (!result || result.index !== rest.length - rest.trimStart().length) return
    if (!isAppointment(text, word.end + result.index, result, lang)) return
    const { date, time, period } = whenValueOf(result, lang)
    if (isPast({ date }, options.now)) return
    const end = word.end + result.index + result.text.length
    found.push({ kind: 'deadline', start: word.start, end, text: text.slice(word.start, end), value: { date, time, period } })
  })
  return found
}
